import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

/**
 * Loading fallback for lazy-loaded routes
 * Shows a centered spinner while the route component loads
 */
export function RouteLoader() {
  const { t } = useTranslation('common');

  return (
    <div className="flex items-center justify-center min-h-[400px] w-full">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">{t('status.loading')}</p>
      </div>
    </div>
  );
}
